// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rjZHrFHn7cNNtTBHCRHy {
  position: absolute;
  width: 12rem;
}

.MOmRg4jbyQYifoZI0Cto {
  overflow-y: clip
}

.MOmRg4jbyQYifoZI0Cto.qQNu87g3xPN5tpyR6Afc {
    height: calc(100% - 8.25rem);
  }

.MOmRg4jbyQYifoZI0Cto.JSBD9nZBCgSbnd4nIiS8 {
    height: calc(100% - 5.875rem);
  }

.MOmRg4jbyQYifoZI0Cto.y6vc71jpsfAe9GThKGsG {
    height: calc(100% - 4.125rem);
  }

.qQNu87g3xPN5tpyR6Afc {
  right: 4.125rem;
  top: 8.25rem;
}

.JSBD9nZBCgSbnd4nIiS8 {
  right: 1.8125rem;
  top: 5.875rem;
}

.y6vc71jpsfAe9GThKGsG {
  right: 0.9375rem;
  top: 4.125rem;
}

.TcSq2tNIvTyt4fzNsmev.rjZHrFHn7cNNtTBHCRHy {
    width: 12.1875rem;
  }

.TcSq2tNIvTyt4fzNsmev.JSBD9nZBCgSbnd4nIiS8 {
    top: 5.9375rem;
  }

.TcSq2tNIvTyt4fzNsmev.y6vc71jpsfAe9GThKGsG {
    top: 4.25rem;
  }

.TcSq2tNIvTyt4fzNsmev.MOmRg4jbyQYifoZI0Cto.JSBD9nZBCgSbnd4nIiS8 {
      height: calc(100% - 5.9375rem);
    }

.TcSq2tNIvTyt4fzNsmev.MOmRg4jbyQYifoZI0Cto.y6vc71jpsfAe9GThKGsG {
      height: calc(100% - 4.25rem);
    }

.NIWVIqQA7FDVR0KT4gGS.rjZHrFHn7cNNtTBHCRHy {
    width: 7.5rem;
  }

.NIWVIqQA7FDVR0KT4gGS.qQNu87g3xPN5tpyR6Afc {
    right: 3.75rem;
    top: 5.0625rem;
  }

.NIWVIqQA7FDVR0KT4gGS.JSBD9nZBCgSbnd4nIiS8 {
    right: 1.375rem;
    top: 3.5625rem;
  }

.NIWVIqQA7FDVR0KT4gGS.y6vc71jpsfAe9GThKGsG {
    top: 1.875rem;
    right: 1.25rem;
  }

.NIWVIqQA7FDVR0KT4gGS.MOmRg4jbyQYifoZI0Cto.qQNu87g3xPN5tpyR6Afc {
      height: calc(100% - 5.0625rem);
    }

.NIWVIqQA7FDVR0KT4gGS.MOmRg4jbyQYifoZI0Cto.JSBD9nZBCgSbnd4nIiS8 {
      height: calc(100% - 3.5625rem);
    }

.NIWVIqQA7FDVR0KT4gGS.MOmRg4jbyQYifoZI0Cto.y6vc71jpsfAe9GThKGsG {
      height: calc(100% - 1.875rem);
    }
`, "",{"version":3,"sources":["webpack://./src/components/Hand/Hand.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;AAaF;;AAXE;IACE,4BAA0B;EAC5B;;AAEA;IACE,6BAAyB;EAC3B;;AAEA;IACE,6BAAyB;EAC3B;;AAGF;EACE,eAAW;EACX,YAAU;AACZ;;AAEA;EACE,gBAAW;EACX,aAAS;AACX;;AAEA;EACE,gBAAW;EACX,aAAS;AACX;;AAGE;IACE,iBAAY;EACd;;AAEA;IACE,cAAS;EACX;;AAEA;IACE,YAAS;EACX;;AAGE;MACE,8BAAyB;IAC3B;;AAEA;MACE,4BAAyB;IAC3B;;AAKF;IACE,aAAY;EACd;;AAEA;IACE,cAAW;IACX,cAAS;EACX;;AAEA;IACE,eAAW;IACX,cAAS;EACX;;AAEA;IACE,aAAS;IACT,cAAW;EACb;;AAGE;MACE,8BAAyB;IAC3B;;AAEA;MACE,8BAAyB;IAC3B;;AAEA;MACE,6BAAyB;IAC3B","sourcesContent":[".handContainer {\n  position: absolute;\n  width: 192px;\n}\n\n.cropped {\n  overflow-y: clip;\n\n  &.hand1Container {\n    height: calc(100% - 132px);\n  }\n\n  &.hand2Container {\n    height: calc(100% - 94px);\n  }\n\n  &.hand3Container {\n    height: calc(100% - 66px);\n  }\n}\n\n.hand1Container {\n  right: 66px;\n  top: 132px;\n}\n\n.hand2Container {\n  right: 29px;\n  top: 94px;\n}\n\n.hand3Container {\n  right: 15px;\n  top: 66px;\n}\n\n.tablet {\n  &.handContainer {\n    width: 195px;\n  }\n\n  &.hand2Container {\n    top: 95px;\n  }\n\n  &.hand3Container {\n    top: 68px;\n  }\n\n  &.cropped {\n    &.hand2Container {\n      height: calc(100% - 95px);\n    }\n\n    &.hand3Container {\n      height: calc(100% - 68px);\n    }\n  }\n}\n\n.mobile {\n  &.handContainer {\n    width: 120px;\n  }\n\n  &.hand1Container {\n    right: 60px;\n    top: 81px;\n  }\n\n  &.hand2Container {\n    right: 22px;\n    top: 57px;\n  }\n\n  &.hand3Container {\n    top: 30px;\n    right: 20px;\n  }\n\n  &.cropped {\n    &.hand1Container {\n      height: calc(100% - 81px);\n    }\n\n    &.hand2Container {\n      height: calc(100% - 57px);\n    }\n\n    &.hand3Container {\n      height: calc(100% - 30px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"handContainer": `rjZHrFHn7cNNtTBHCRHy`,
	"cropped": `MOmRg4jbyQYifoZI0Cto`,
	"hand1Container": `qQNu87g3xPN5tpyR6Afc`,
	"hand2Container": `JSBD9nZBCgSbnd4nIiS8`,
	"hand3Container": `y6vc71jpsfAe9GThKGsG`,
	"tablet": `TcSq2tNIvTyt4fzNsmev`,
	"mobile": `NIWVIqQA7FDVR0KT4gGS`
};
export default ___CSS_LOADER_EXPORT___;
